export default __webpack_public_path__ + "static/media/favoritos.208e4a85.svg";